import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent {

  message: string = "Are you sure?"
  titleText: string = "";
  //confirmButtonText = "Yes"
  confirmButtonText = "OK"
  cancelButtonText = "Cancel"
  showRedirectButton: false;
  redirectButtonText = "";
  redirectButtonUrl = "";

  MessageBoxType: string = "";
  cssClass = "";
  icon = "";
  ShowPiiresult: boolean = false;
  Piiresponsemessage: string = "";
  piiresponsestatus: boolean = false;
  piiresponsetext: string = "";
  wisdomnetresponse: string = "";
  showwisdomnext: boolean = false;
  responseButtonText="";
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,@Inject(MAT_DIALOG_DATA) private data1: any,
    public piiresponse: MatDialogRef<ConfirmationDialogComponent>) {
    if (data) {

      this.message = data.message || this.message;
      this.titleText = data.title || "";
      this.MessageBoxType = data.messageBoxType || "confirmation";
      this.icon = data.icon || "";
      this.cssClass = data.cssClass || "";
      this.piiresponsestatus = data.piiresponse || false,
        this.piiresponsetext = data.piiresponsetext || "",
        this.wisdomnetresponse = data.wisdomnetresponse || ""
      if (this.piiresponsestatus) {
        this.showpiiresponse(this.message, this.piiresponsetext, this.piiresponsestatus);
      }
      if (data.buttonText) {
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
      if (data.showRedirectButton) {
        this.showRedirectButton = data.showRedirectButton;
        this.redirectButtonText = data.redirectButtonText;
        this.redirectButtonUrl = data.redirectButtonUrl;
      }
    }
    if(data1){

    }
  }
  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  redirectButtonClicked() {
    this.dialogRef.close();
  }
  showpiiresponse(text, piiresponsetext, piiresponsestatus) {
    this.Piiresponsemessage = piiresponsetext;
    this.ShowPiiresult = true;
  }
  showpiidata(){
    this.showwisdomnext = true;
     this.responseButtonText ="Close";
  }
  closeresponse(){
    this.showwisdomnext = false;
  }
}
